<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ (isWorkshop ? "bikeshop.shop_profile.collections.pick_ups_&_delivery" : "bikeshop.shop_setup.card_headers.rental_deliveries_and_collections") | translate }}
</span>
    </div>
  </div>

  <div class="row" *ngIf="allLinkedPartners && allLinkedPartners.length > 0 && isWorkshop">
    <div class="col-md-6">
      <p-accordion>
        <p-accordionTab header="{{ 'bikeshop.shop_profile.collections.store_configuration' | translate }}" [selected]="
          true">
          <div class="partner-configuration">
            <div>
              <div></div>
              <div><span>{{ 'bikeshop.shop_profile.collections.can_do_collections' | translate }}</span></div>
              <div><span>{{ 'bikeshop.shop_profile.collections.can_do_deliveries' | translate }}</span></div>
            </div>
            <div *ngFor="let partner of allLinkedPartners">
              <div class="bold">{{partner.partnerName}}</div>
              <div>
                <p-inputSwitch [(ngModel)]="partner.collectionsEnabled" (onChange)="updatePartnerMasterConfig(partner)">
                </p-inputSwitch>
              </div>
              <div>
                <p-inputSwitch [(ngModel)]="partner.deliveriesEnabled" (onChange)="updatePartnerMasterConfig(partner)">
                </p-inputSwitch>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <div *ngIf="canConfigureStores()">
    <div class="row">
      <div class="col-md-7" style="display: flex;">
        <div class="content">
          <div class="title">{{ (isRentals ? 'bikeshop.shop_profile.collections.rental_delivery_areas' : 'bikeshop.shop_profile.collections.delivery_areas') | translate}}</div>
          <div class="loader" *ngIf="loadingDeliveryAreas"></div>
          <div class="info" *ngIf="!loadingDeliveryAreas && deliveryAreas.length === 0">
            {{ (isRentals ? 'bikeshop.shop_profile.collections.rental_delivery_areas_empty' : 'bikeshop.shop_profile.collections.delivery_areas_empty') | translate}}</div>
          <table class="data" *ngIf="deliveryAreas.length > 0">
            <tr>
              <th>{{'bikeshop.shop_profile.collections.area_name' | translate}}</th>
              <!-- <th>{{'bikeshop.shop_profile.collections.collections' | translate}}</th>
            <th>{{'bikeshop.shop_profile.collections.deliveries' | translate}}</th> -->
              <th>{{'bikeshop.shop_profile.collections.collection_fee' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.delivery_fee' | translate}}</th>
              <th *ngIf="allLinkedPartners && allLinkedPartners.length > 1">
                {{'bikeshop.shop_profile.collections.linked_stores' | translate}}</th>
              <th>
                <span class="hubtiger-add pull-right" (click)="addNew('Area')"></span>
              </th>
            </tr>
            <tbody>
              <tr *ngFor="let item of deliveryAreas">
                <td class="bold">{{item.areaName}}</td>
                <!-- <td>{{item.canDoCollections ? ('general.yes' | translate) : ('general.no' | translate)}}</td>
                 <td>{{item.canDoDeliveries ? ('general.yes' | translate) : ('general.no' | translate)}}</td> -->
                <td><div *ngIf="!item.collectionProduct">-</div><div *ngIf="item.collectionProduct">{{currencySymbol}}{{(VATInclusive ? item.collectionProduct.unitPrice_IncludingTax : item.collectionProduct.unitPrice) | number : '.2-2'}} / {{item.collectionProduct.sku}}</div></td>
                <td><div *ngIf="!item.deliveryProduct">-</div><div *ngIf="item.deliveryProduct">{{currencySymbol}}{{(VATInclusive ? item.deliveryProduct.unitPrice_IncludingTax : item.deliveryProduct.unitPrice) | number : '.2-2'}} / {{item.deliveryProduct.sku}}</div></td>
                <td *ngIf="allLinkedPartners && allLinkedPartners.length > 1">
                  <ul>
                    <li *ngFor="let partner of item.linkedPartners">{{getPartnerName(partner.partnerID)}}</li>
                  </ul>
                </td>
                <td>
                  <span class="fa hubtiger-edit" (click)="editRecord(item, 'Area')"></span>
                  <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'Area')"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!loadingDeliveryAreas && deliveryAreas.length === 0" class="margin-top-16 create-new">
            <button pButton type="button" class="p-button-raised full-width accent"
              label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}" (click)="addNew('Area')"></button>
          </div>

        </div>
      </div>

      <div class="col-md-5" style="display: flex;">
        <div class="content">
          <div class="title">{{'bikeshop.shop_profile.collections.delivery_vehicles' | translate}}</div>
          <div class="loader" *ngIf="loadingVehicleList"></div>
          <div class="info" *ngIf="!loadingVehicleList && vehicleList.length === 0">
            {{'bikeshop.shop_profile.collections.delivery_vehicles_empty' | translate}}</div>
          <table class="data" *ngIf="vehicleList.length > 0">
            <tr>
              <th style="min-width: 100px;">{{'bikeshop.shop_profile.collections.name' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.max_bikes' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.linked_areas' | translate}}</th>
              <th>
                <span class="hubtiger-add pull-right" *ngIf="canAddVehicle()" (click)="addNew('Vehicle')"></span>
              </th>
            </tr>
            <tbody>
              <tr *ngFor="let item of vehicleList">
                <td class="bold">{{item.name}}</td>
                <td>{{item.maxBikes}}</td>
                <td>
                  <ul *ngIf="item.linkedAreas.length > 0">
                    <li *ngFor="let item of item.linkedAreas">{{item.areaName}}</li>
                  </ul>
                  <div *ngIf="item.linkedAreas.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <span class="fa hubtiger-edit" (click)="editRecord(item, 'Vehicle')"></span>
                  <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'Vehicle')"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="invalid" *ngIf="!canAddVehicle() && !loadingDeliveryAreas">
            {{ 'bikeshop.shop_profile.collections.cannot_create_vehicle' | translate }}
          </div>
          <div *ngIf="!loadingVehicleList && vehicleList.length === 0 && canAddVehicle()" class="margin-top-16 create-new">
            <button pButton type="button" class="p-button-raised full-width accent"
              label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
              (click)="addNew('Vehicle')"></button>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <!-- <div class="col-md-12" style="display: flex;">
      <div class="content">
        <div class="title">{{'bikeshop.shop_profile.collections.cut_off_times' | translate}}</div>
        <div class="loader" *ngIf="loadingCutOffRules"></div>
        <div class="info" *ngIf="!loadingCutOffRules && cutOffRules.length === 0">
          {{'bikeshop.shop_profile.collections.cut_off_times_empty' | translate}}</div>
        <table class="data" *ngIf="cutOffRules.length > 0">
          <tr>
            <th>{{'bikeshop.calendar.day' | translate}}</th>
            <th>***{{'bikeshop.shop_profile.collections.buffer_days' | translate}}</th>
            <th>{{'bikeshop.shop_profile.collections.cut_off_time' | translate}}</th>
            <th *ngIf="linkedPartners && linkedPartners.length > 1">{{'bikeshop.shop_profile.collections.linked_stores'
              | translate}}</th>
            <th>
              <span class="hubtiger-add pull-right" (click)="addNew('CutOffRule')"></span>
            </th>
          </tr>
          <tbody>
            <tr *ngFor="let item of cutOffRules">
              <td>{{dayOfWeek(item.dayOfWeek)}}</td>
              <td>{{item.bufferDays}}</td>
              <td>{{'1970-01-01 '+item.cutOffTime | date : "h:mm a"}}</td>
              <td *ngIf="linkedPartners && linkedPartners.length > 1">
                <div class="flex">{{item.linkedPartners.length}} / {{linkedPartners.length}} <span
                    *ngIf="isStoreInList(item.linkedPartners)" class="fa fa-check-square"></span></div>
              </td>
              <td>
                <span class="fa hubtiger-edit" (click)="editRecord(item, 'CutOffRule')"></span>
                <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'CutOffRule')"></span>
              </td>
            </tr>
          </tbody>
        </table>
        <small *ngIf="cutOffRules.length > 0">***{{'bikeshop.shop_profile.collections.buffer_days_explanation'
          | translate }}</small>
        <div *ngIf="!loadingCutOffRules && cutOffRules.length === 0" class="margin-top-16 create-new">
          <button pButton type="button" class="p-button-raised full-width accent"
            label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
            (click)="addNew('CutOffRule')"></button>
        </div>
      </div>
    </div> -->
      <div class="col-md-12" style="display: flex;">
        <div class="content">

          <div class="title">{{ (isRentals ? 'bikeshop.shop_profile.collections.rental_default_slots' : 'bikeshop.shop_profile.collections.default_slots') | translate}}</div>
          <div class="loader" *ngIf="loadingDefaultSlots"></div>
          <div class="info" *ngIf="!loadingDefaultSlots && defaultSlots.length === 0">
            {{ (isRentals ? 'bikeshop.shop_profile.collections.rental_default_slots_empty' : 'bikeshop.shop_profile.collections.default_slots_empty') | translate}}</div>

            <div class="row row-unaffected" *ngIf="defaultSlots.length > 0">
              <div class="col-md-3 label flex bold">{{'bikeshop.shop_profile.collections.filter_by_day_of_week' | translate}}:</div>
              <div class="col-md-9">
                <div class="filters-container">
                  <div (click)="defaultSlotDayFilterValue = -1"
                    [ngClass]="{'selected': -1 == defaultSlotDayFilterValue}">{{'general.all' | translate}}</div>
                  <div *ngFor="let day of daysOfWeek" (click)="defaultSlotDayFilterValue = day"
                    [ngClass]="{'selected': day == defaultSlotDayFilterValue}">{{dayOfWeekShort(day)}}</div>
                </div>
              </div>
            </div>
            <div class="row row-unaffected margin-top-8" *ngIf="defaultSlots.length > 0 && getDefaultSlotAreas().length > 1">
              <div class="col-md-3 label flex bold">{{'bikeshop.shop_profile.collections.filter_by_area' | translate}}:</div>
              <div class="col-md-9">
                <div class="filters-container">
                  <div (click)="defaultAreaFilterValue = -1"
                    [ngClass]="{'selected': -1 == defaultAreaFilterValue}">{{'general.all' | translate}}</div>
                  <div *ngFor="let area of getDefaultSlotAreas()" (click)="defaultAreaFilterValue = area"
                    [ngClass]="{'selected': area == defaultAreaFilterValue}">{{area}}</div>
                </div>
              </div>
            </div>


          <table class="data margin-top-16" *ngIf="defaultSlots.length > 0">
            <tr>
              <!-- <th>{{'bikeshop.shop_profile.collections.name' | translate}}</th> -->
              <th>{{'bikeshop.calendar.day' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.slot_time' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.cut_off_time' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.collections' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.deliveries' | translate}}</th>
              <!-- <th *ngIf="allLinkedPartners && allLinkedPartners.length > 1">
                {{'bikeshop.shop_profile.collections.linked_stores'
                | translate}}</th> -->
              <th>{{'bikeshop.shop_profile.collections.linked_vehicles' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.linked_areas' | translate}}</th>
              <th>
                <span class="hubtiger-add pull-right" *ngIf="canAddSlots()" (click)="addNew('Slot')"></span>
              </th>
            </tr>
            <tbody>
              <tr *ngFor="let item of getFilteredDefaultSlots()">
                <!-- <td>{{item.slotName}}</td> -->
                <td class="bold">{{dayOfWeek(item.dayOfWeek)}}</td>
                <td>
                  {{'1970-01-01 '+item.slotStartTime | date : "h:mm a"}} - {{'1970-01-01 '+item.slotEndTime | date : "h:mm a"}}
                </td>
                <td>{{formatCutOffTime('1970-01-01 '+item.cutOffTime)}}, {{dayOfWeek(getBufferDay(item.dayOfWeek, item.bufferDays))}}</td>
                <td>{{item.canDoCollection ? ('general.yes' | translate) : ('general.no' | translate)}}</td>
                <td>{{item.canDoDelivery ? ('general.yes' | translate) : ('general.no' | translate)}}</td>
                <!-- <td *ngIf="allLinkedPartners && allLinkedPartners.length > 1">
                  <div class="flex">{{item.linkedPartners.length}} / {{linkedPartners.length}} <span
                      *ngIf="isStoreInList(item.linkedPartners)" class="fa fa-check-square"></span></div>
                </td> -->
                <td>
                  <div *ngIf="item.linkedVehicles.length > 0">
                    <ul>
                      <li *ngFor="let item of item.linkedVehicles">{{item.name}}</li>
                    </ul>
                  </div>
                  <div *ngIf="item.linkedVehicles.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <ul *ngIf="item.linkedAreas.length > 0">
                    <li *ngFor="let item of item.linkedAreas">{{item.areaName}}</li>
                  </ul>
                  <div *ngIf="item.linkedAreas.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <span class="fa hubtiger-edit" (click)="editRecord(item, 'Slot')"></span>
                  <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'Slot')"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="invalid" *ngIf="defaultSlotDayFilterValue > -1 && getFilteredDefaultSlots().length == 0">
            {{ 'bikeshop.shop_profile.collections.no_records_for_this_filter' | translate }}
          </div>
          <div class="invalid" *ngIf="!canAddSlots() && !loadingVehicleList && !loadingDeliveryAreas">
            {{ 'bikeshop.shop_profile.collections.cannot_create_slots' | translate }}
          </div>
          <div *ngIf="!loadingDefaultSlots && defaultSlots.length === 0  && canAddSlots()"
            class="margin-top-16 create-new">
            <button pButton type="button" class="p-button-raised full-width accent"
              label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}" (click)="addNew('Slot')"></button>
          </div>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7" style="display: flex;">
        <div class="content">
          <div class="title">{{'bikeshop.shop_profile.collections.override_slots' | translate}}</div>
          <div class="loader" *ngIf="loadingOverrideSlots"></div>
          <div class="info" *ngIf="!loadingOverrideSlots && overrideSlots.length === 0">
            {{'bikeshop.shop_profile.collections.override_slots_empty' | translate}}</div>

          <table class="data" *ngIf="overrideSlots.length > 0">
            <tr>
              <!-- <th>{{'bikeshop.shop_profile.collections.name' | translate}}</th> -->
              <th>{{'bikeshop.shop_profile.collections.override_date' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.slot_time' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.cut_off_time' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.linked_vehicles' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.linked_areas' | translate}}</th>
              <th>
                <span *ngIf="canAddOverrideSlots()" class="hubtiger-add pull-right"
                  (click)="addNew('OverrideSlot')"></span>
              </th>
            </tr>
            <tbody>
              <tr *ngFor="let item of overrideSlots">
                <!-- <td>{{item.slotName}}</td> -->
                <td class="bold">{{item.date | date : countryData.AngularDateFormat}}</td>
                <td>{{'1970-01-01 '+item.slotStartTime | date : "h:mm a"}} - {{'1970-01-01 '+item.slotEndTime | date :
                  "h:mm a"}}</td>
                <td>{{formatCutOffTime('1970-01-01 '+item.cutOffTime)}}, {{getBufferDate(item.date, item.bufferDays)}}</td>
                <td>
                  <ul *ngIf="item.linkedVehicles.length > 0">
                    <li *ngFor="let item of item.linkedVehicles">{{item.name}}</li>
                  </ul>
                  <div *ngIf="item.linkedVehicles.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <ul *ngIf="item.linkedAreas.length > 0">
                    <li *ngFor="let item of item.linkedAreas">{{item.areaName}}</li>
                  </ul>
                  <div *ngIf="item.linkedAreas.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <span class="fa hubtiger-edit" (click)="editRecord(item, 'OverrideSlot')"></span>
                  <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'OverrideSlot')"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="invalid" *ngIf="!canAddOverrideSlots() && !loadingVehicleList">
            {{ 'bikeshop.shop_profile.collections.cannot_create_custom_slots' | translate }}
          </div>
          <div *ngIf="!loadingOverrideSlots && overrideSlots.length === 0 && canAddOverrideSlots()"
            class="margin-top-16 create-new">
            <button pButton type="button" class="p-button-raised full-width accent"
              label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
              (click)="addNew('OverrideSlot')"></button>
          </div>
        </div>
      </div>
      <div class="col-md-5" style="display: flex;">
        <div class="content">
          <div class="title">{{'bikeshop.shop_profile.collections.unavailable_dates' | translate}}</div>
          <div class="loader" *ngIf="loadingUnavailableDates"></div>
          <div class="info" *ngIf="!loadingUnavailableDates && unavailableDates.length === 0">
            {{'bikeshop.shop_profile.collections.unavailable_dates_empty' | translate}}</div>

          <table class="data" *ngIf="unavailableDates.length > 0">
            <tr>
              <!-- <th>{{'bikeshop.shop_profile.collections.name' | translate}}</th> -->
              <th>{{'bikeshop.shop_profile.collections.unavailable_date' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.slot_time' | translate}}</th>
              <th>{{'bikeshop.shop_profile.collections.linked_vehicles' | translate}}</th>
              <th>
                <span *ngIf="canAddOverrideSlots" class="hubtiger-add pull-right"
                  (click)="addNew('UnavailableDate')"></span>
              </th>
            </tr>
            <tbody>
              <tr *ngFor="let item of unavailableDates">
                <!-- <td>{{item.slotName}}</td> -->
                <td class="bold">{{item.date | date : countryData.AngularDateFormat}}</td>
                <td>{{'1970-01-01 '+item.startTime | date : "h:mm a"}} - {{'1970-01-01 '+item.endTime | date : "h:mm
                  a"}}
                </td>
                <td>
                  <ul *ngIf="item.linkedVehicles.length > 0">
                    <li *ngFor="let item of item.linkedVehicles">{{item.name}}</li>
                  </ul>
                  <div *ngIf="item.linkedVehicles.length === 0" class="none-linked">{{
                    'bikeshop.shop_profile.collections.none_linked' | translate }}</div>
                </td>
                <td>
                  <span class="fa hubtiger-edit" (click)="editRecord(item, 'UnavailableDate')"></span>
                  <span class="fa hubtiger-delete" (click)="deleteRecord(item, 'UnavailableDate')"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="invalid" *ngIf="!canAddOverrideSlots() && !loadingVehicleList">
            {{ 'bikeshop.shop_profile.collections.cannot_create_unavailable_dates' | translate }}
          </div>
          <div *ngIf="!loadingUnavailableDates && unavailableDates.length === 0 && canAddOverrideSlots()"
            class="margin-top-16 create-new">
            <button pButton type="button" class="p-button-raised full-width accent"
              label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}"
              (click)="addNew('UnavailableDate')"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog key="delete_item"></p-confirmDialog>

<p-sidebar #NavSideBar1 [(visible)]="showDeliveryAreaConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="areaChanged(); NavSideBar1.destroyModal() ">
  <div *ngIf="showDeliveryAreaConfig">
    <app-delivery-area-config [data]="panelData" [areas]="deliveryAreas" [isWorkshop]="isWorkshop" [isRentals]="isRentals" [linkedPartners]="linkedPartners" (close)="close()">
    </app-delivery-area-config>
  </div>
</p-sidebar>

<p-sidebar #NavSideBar2 [(visible)]="showVehicleConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="vehicleChanged(); NavSideBar2.destroyModal() ">
  <div *ngIf="showVehicleConfig">
    <app-delivery-vehicle-config [data]="panelData" [areas]="deliveryAreas" [linkedPartners]="linkedPartners"
      (close)="close()">
    </app-delivery-vehicle-config>
  </div>
</p-sidebar>

<!-- <p-sidebar [(visible)]="showCutOffTimeConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="getCutOffRules()">
  <div *ngIf="showCutOffTimeConfig">
    <app-cut-off-time-config [data]="panelData" [linkedPartners]="linkedPartners" [configuredCutOffRules]="cutOffRules"
      (close)="close()"></app-cut-off-time-config>
  </div>
</p-sidebar> -->

<p-sidebar #NavSideBar3 [(visible)]="showDefaultSlotsConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="getDefaultSlots(); NavSideBar3.destroyModal()">
  <div *ngIf="showDefaultSlotsConfig">
    <app-default-slots-config [data]="panelData" [linkedPartners]="linkedPartners" (close)="close()"
      [vehicles]="vehicleList" [areas]="deliveryAreas" [isWorkshop]="isWorkshop" [isRentals]="isRentals"></app-default-slots-config>
  </div>
</p-sidebar>

<p-sidebar #NavSideBar4 [(visible)]="showUnavailableDatesConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="getUnavailableDates(); NavSideBar4.destroyModal()">
  <div *ngIf="showUnavailableDatesConfig">
    <app-unavailable-dates-config [data]="panelData" [configuredSlots]="defaultSlots" [vehicles]="vehicleList"
      (close)="close()">
    </app-unavailable-dates-config>
  </div>
</p-sidebar>

<p-sidebar #NavSideBar5 [(visible)]="showOverrideSlotsConfig" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="getOverrideSlots(); NavSideBar5.destroyModal()">
  <div *ngIf="showOverrideSlotsConfig">
    <app-override-slots-config [data]="panelData" [configuredSlots]="defaultSlots"
      [vehicles]="vehicleList" [areas]="deliveryAreas" (close)="close()" [isWorkshop]="isWorkshop" [isRentals]="isRentals">
    </app-override-slots-config>
  </div>
</p-sidebar>
